<template>
  <div class="navbar-right ">
    <ul class="nav navbar-nav m-n hidden-xs nav-user user">
      <li class="hidden-xs">
        <a href="#" class="dropdown-toggle lt" @click="showMall('mall')">
          <i class="icon-basket-loaded"></i>
        </a>
      </li>         
      <el-dropdown @command="handleCommand">
        <span class="thumb-sm avatar user">
          <img src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png" alt="...">
          {{user.userName}} <b class="caret"></b>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="pwd">修改密码</el-dropdown-item>
          <el-dropdown-item command="lockScreen">安全锁屏</el-dropdown-item>
          <el-dropdown-item command="help">帮助文档</el-dropdown-item>
          <el-dropdown-item command="soft" disabled>桌面软件</el-dropdown-item>
          <el-dropdown-item command="soft" disabled>我的订单</el-dropdown-item>
          <el-dropdown-item command="kefu">联系客服</el-dropdown-item>
          <el-dropdown-item command="logout" divided>退出登陆</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>         
    </ul>
    <EditPwd :dialogEditPwd="dialogEditPwd"></EditPwd>
    <LockScreen :dialogLockScreen="dialogLockScreen"></LockScreen>
  </div>
</template>

<script>
import EditPwd from './EditPwd'
import LockScreen from './lockScreen'
export default {
  data (){
    return {  
      user:{},
      dialogEditPwd:{
        isShow:false,
      },
      dialogLockScreen:{
        isShow:false
      }
    }
  },
  components: {
    EditPwd,
    LockScreen
  },
  computed:{  
	},
  mounted:function(){
    this.user = this.$cookie.getJSON('user');
  },
  methods:{
    handleCommand(command) {
      if(command=='pwd'){
        this.dialogEditPwd.isShow = true
      }else if(command=='lockScreen'){
        this.dialogLockScreen.isShow = true
      }else if(command=='help'){
        window.open("https://docs.qq.com/doc/DZktqcGZqZkFOQnVs", '_blank');
      }else if(command=='logout'){
        sessionStorage.setItem('token','')
        this.$cookie.set('user', '');
        sessionStorage.setItem('menus','')
        this.$router.push('/');
      }else if(command=='kefu'){
        window.open("tencent://message/?Menu=yes&uin=412559867", '_blank');
      }
    },
    showMall(){
      this.$router.push("mall")
    }
  }
}
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.el-dropdown
  margin-right 90px
.user
  margin-top 10px
  color #fff
</style>